var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadius3Icon = function SvgRadius3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.25 3.75A8.25 8.25 0 0 0 4 12v.5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V12c0-5.385 4.365-9.75 9.75-9.75h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgRadius3Icon;